// Novos DNAs · Boas-vindas automática no WhatsApp após a pré-matrícula
import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => {
  const t = localStorage.getItem("token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

const waLink = (phone, msg) => {
  const digits = String(phone || "").replace(/\D/g, "");
  const full = digits.startsWith("55") ? digits : `55${digits}`;
  return `https://wa.me/${full}?text=${encodeURIComponent(msg || "")}`;
};

export const WelcomeCard = ({ prospect, onUpdated, styles: S }) => {
  const p = prospect;
  const w = p.welcome_whatsapp || {};
  const [text, setText] = useState(w.text || "");
  const [busy, setBusy] = useState("");

  const sent = w.status === "sent";
  const url = waLink(w.phone || p.responsible_phone_norm || p.responsible_phone, text || w.text);

  const prepare = async () => {
    setBusy("prepare");
    try {
      const { data } = await axios.post(`${API}/prospects/${p.id}/welcome/send`, {}, { headers: authHeaders() });
      setText(data.text || "");
      if (data.status === "sent") toast.success("Boas-vindas enviada automaticamente pelo WhatsApp.");
      else if (data.status === "failed") toast.error("Envio automático falhou: " + (data.error || ""));
      else toast.info("Mensagem pronta — envie em 1 clique pelo WhatsApp.");
      onUpdated && onUpdated({ ...p, welcome_whatsapp: data });
    } catch (e) {
      toast.error("Erro: " + (e?.response?.data?.detail || e.message));
    } finally { setBusy(""); }
  };

  const markSent = async () => {
    setBusy("mark");
    try {
      const { data } = await axios.post(`${API}/prospects/${p.id}/welcome/mark-sent`,
        { channel: "whatsapp", message: text || w.text },
        { headers: authHeaders() });
      toast.success("Boas-vindas registrada como enviada.");
      onUpdated && onUpdated({ ...p, welcome_whatsapp: data });
    } catch (e) {
      toast.error("Erro: " + (e?.response?.data?.detail || e.message));
    } finally { setBusy(""); }
  };

  return (
    <div style={S.actionCard} data-testid="novosdna-welcome-card">
      <div style={S.actionCardHead}>
        💜 Boas-vindas da família
        <span style={{
          marginLeft: 8, fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 999,
          background: sent ? "#ecfdf5" : w.status === "failed" ? "#fef2f2" : "#fefce8",
          color: sent ? "#047857" : w.status === "failed" ? "#b91c1c" : "#a16207",
        }} data-testid="novosdna-welcome-status">
          {sent ? "Enviada" : w.status === "failed" ? "Falhou" : w.text ? "Pronta para enviar" : "Não gerada"}
        </span>
      </div>

      {w.reason && !sent && (
        <div style={{ fontSize: 11, color: "#6b6483", marginBottom: 6 }}>{w.reason}</div>
      )}
      {w.error && (
        <div style={{ fontSize: 11, color: "#b91c1c", marginBottom: 6 }}>{w.error}</div>
      )}
      {sent && (
        <div style={{ fontSize: 11, color: "#047857", marginBottom: 6 }}>
          Enviada em {String(w.sent_at || "").slice(0, 16).replace("T", " ")} · {w.mode === "manual" ? "envio manual" : "automático"}
        </div>
      )}

      <textarea value={text} onChange={(e) => setText(e.target.value)}
        placeholder="Clique em Gerar mensagem para criar o texto de boas-vindas"
        data-testid="novosdna-welcome-text"
        style={{ ...S.input, minHeight: 90, resize: "vertical" }} />

      <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
        <button onClick={prepare} disabled={busy === "prepare"} data-testid="novosdna-welcome-generate"
          style={{ ...S.btnAction("#7B3F98"), flex: 1 }}>
          {busy === "prepare" ? "Gerando…" : sent ? "Gerar novamente" : "Gerar / enviar automático"}
        </button>
        <a href={url} target="_blank" rel="noreferrer" onClick={markSent} data-testid="novosdna-welcome-wa"
          style={{ ...S.btnAction("#25D366"), flex: 1, textDecoration: "none", textAlign: "center" }}>
          Enviar pelo WhatsApp
        </a>
      </div>
    </div>
  );
};

export default WelcomeCard;
